'use client';

import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@sola/ark-core/atoms/badge/badge.js';
import {
  RadioGroupCheckbox,
  RadioGroupCheckboxItem,
} from '@sola/ark-core/molecules/radio-group-checkbox/radio-group-checkbox.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { PaymentMethodTypesEnum } from '@sola/shared-utils/my/payment-method-type-guards.js';

interface PaymentMethodSwitchProps {
  setSelectedPaymentMethod: Dispatch<SetStateAction<PaymentMethodTypesEnum>>;
}

export const PaymentMethodSwitch = ({
  setSelectedPaymentMethod,
}: PaymentMethodSwitchProps) => {
  const { t } = useTranslation('my');
  return (
    <div>
      <RadioGroupCheckbox
        label={t('addPaymentMethod.form.leadin')}
        defaultValue={PaymentMethodTypesEnum.Bank}
        onChange={setSelectedPaymentMethod}
      >
        {/** Bank Button */}
        <RadioGroupCheckboxItem value={PaymentMethodTypesEnum.Bank}>
          <span className="flex flex-col gap-snug-md">
            <ArkIcon iconName="bank" width="1.5rem" height="1.5rem" />
            <div className="flex gap-snug-lg">
              {t('addPaymentMethod.switchLabels.bank')}
              <Badge color="positive" label="Preferred" size="sm" />
            </div>
          </span>
        </RadioGroupCheckboxItem>

        {/** Card Button */}
        <RadioGroupCheckboxItem value={PaymentMethodTypesEnum.Card}>
          <span className="flex flex-col gap-snug-md">
            <ArkIcon iconName="credit-card-02" width="1.5rem" height="1.5rem" />
            <div className="flex gap-snug-lg">
              {t('addPaymentMethod.switchLabels.card')}
            </div>
          </span>
        </RadioGroupCheckboxItem>
      </RadioGroupCheckbox>
      <div />
    </div>
  );
};
